import React from "react";
import NonAppliedImg from "../../../../assets/profile/nonAppliedImg.png";
import { useTranslation } from "react-i18next";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import { useAppDispatch } from "../../../../store/store";
import { setAffiliatesJoinPopupOpen } from "../../../../store/features/affiliatesSlice";
import { useMediaQuery } from "@mui/material";
import { ProfileAffiliatesHeaderMobile } from "./ProfileAffiliatesHeaderMobile";

export const NonAppliedScreen = () => {
  const { t } = useTranslation(["profile"]);
  const langTheme = useLanguageTheme();
  const dispatch = useAppDispatch();
  const is970px = useMediaQuery("(max-width: 970px)");

  return (
    <div
      className="non-applied-screen-wrapper"
      style={{
        fontFamily: langTheme.mainFont(),
      }}
    >
      {is970px && <ProfileAffiliatesHeaderMobile />}
      <div className="non-applied-screen-main-title">{t("affiliates")}</div>
      <div className="non-applied-screen-info-container">
        <div className="non-applied-screen-info-wrapper">
          <img src={NonAppliedImg} />
          <div className="non-applied-screen-title">
            {t("join_our_affiliate_program")}
          </div>
          <div className="non-applied-screen-desc">
            {t("join_our_affiliate_program_desc")}
          </div>
          <div
            className="non-applied-screen-start-btn"
            onClick={() => dispatch(setAffiliatesJoinPopupOpen())}
          >
            {t("start")}
          </div>
        </div>
      </div>
    </div>
  );
};
